import Axios from "./axiosInstance"

export async function fetchQuestionList() {
    try {
        let url = 'planner/questions/';
        const resp = await Axios.get(url);
        return {
            status: true,
            data: resp.data,
            message: '',
        };
    } catch (error) {
        let errorMessage = 'An error occurred while fetching question list.';
        if (error.response) {
            errorMessage = error.response.data.message || error.response.data || error.message;
        } else if (error.message) {
            errorMessage = error.message;
        }

        console.error(errorMessage);

        return {
            status: false,
            message: errorMessage,
            data: [],
        };
    }
};


export async function postUserChoice(body,handleModel,setComplete,setCurrentStep,setSelection,setLoading) {
    try {
        let url = 'planner/planit/';
        const resp = await Axios.post(url,body);
        setComplete(true);
        if(handleModel)
        handleModel();
        setComplete(false);
        setCurrentStep(1);
        setSelection({});
        setLoading(false)
        return {
            status: true,
            data: resp.data,
            message: '',
        };
    } catch (error) {
        setLoading(false)
        let errorMessage = 'An error occurred while fetching question list.';
        if (error.response) {
            errorMessage = error.response.data.message || error.response.data || error.message;
        } else if (error.message) {
            errorMessage = error.message;
        }

        console.error(errorMessage);

        return {
            status: false,
            message: errorMessage,
            data: [],
        };
    }
};

export async function fetchStores(page=1,type,setLoading,id=null) {
    try {
        let url = `data-aggregator/places-events/?page=${page}${type?`&type=${type}`:""}`;
        if(id)
         url = `/data-aggregator/places-events/${id}/`;
        const resp = await Axios.get(url);
        // if(setLoading)
        // setLoading(false)
    if(id)
    return {
        status: true,
        data: resp.data,
        next:resp.data?.next,
        previous:resp.data?.previous,
        count:resp.data?.count,
        message: '',
    };
    else
    return {
        status: true,
        data: resp.data.results,
        next:resp.data?.next,
        previous:resp.data?.previous,
        count:resp.data?.count,
        message: '',
    };
    } catch (error) {
        let errorMessage = 'An error occurred while fetching question list.';
        if (error.response) {
            errorMessage = error.response.data.message || error.response.data || error.message;
        } else if (error.message) {
            errorMessage = error.message;
        }

        console.error(errorMessage);
        if(setLoading)
        setLoading(false)
        return {
            status: false,
            message: errorMessage,
            data: [],
        };
    }
};

export async function fetchHotelDetails() {
    try {
        let url = 'accounts/hotels/';
        const resp = await Axios.get(url);
        localStorage.setItem("hotelInfo",JSON.stringify(resp.data))
        return {
            status: true,
            data: resp.data,
            message: '',
        };
    } catch (error) {
        let errorMessage = 'An error occurred while fetching question list.';
        if (error.response) {
            errorMessage = error.response.data.message || error.response.data || error.message;
        } else if (error.message) {
            errorMessage = error.message;
        }

        console.error(errorMessage);

        return {
            status: false,
            message: errorMessage,
            data: [],
        };
    }
};
